import os from '@utils/os'
let isInApp = navigator.userAgent.indexOf('YPAPP') !== -1

export default class NativeBridge {

    static actionSupportMap = {
        share: 'share',
        pushNative: 'pushNative',
        pushWeb: 'pushWeb',
        notice: 'notice',
        getData: 'getData',
        pay: 'pay',
        getStorage: 'getStorage'
    }

    constructor({
        store,
        router,
        vm
    }) {
        this.os = 'unknow'
        if (os.isAndroid()) {
            this.os = 'android'
        } else if (os.isIOS()) {
            this.os = 'ios'
        } else if (os.getDevice() === 'mac') {
            this.os = 'mac'
        }

        this.vm = vm
        this.callbackCache = undefined
    }

    isSupportAction(actionName) {
        return !!NativeBridge.actionSupportMap[actionName]
    }

    sendMessage(message) {
        if (!isInApp || !message.actionName) return
        if (!message.extend) console.error('数据对象不正确')
        if (!this.isSupportAction(message.actionName)) console.error('不支持的action')
        if (message.actionName === 'pushNative') {
            const { params = {}, pageName } = message.params.data
            if (!pageName || (pageName === 'newWeb' && !params.url)) return
        }
        try {
            if (message.actionName == 'pushNative') {
                message.extend({
                    userInfo: {
                        ...this.vm.$store.getters.userInfo,
                        userid: localStorage.getItem('userid'),
                        token: localStorage.getItem('token'),
                        refresh_token: localStorage.getItem('refresh_token'),
                        sys_token: localStorage.getItem('sys_token')
                    }
                })
            }
            if (message.callback) {
                this.callbackCache = message.callback
                delete message['callback']
            }
            let jsonStr = JSON.stringify(message)
            // if (os.isPC()) {
            //     console.log('PC阻止发送消息', message)
            //     return
            // }
            if (this.os === 'ios' || this.os === 'mac') {
                if (message.actionName === 'getData') return window.prompt(jsonStr)
                return window.webkit.messageHandlers.js2native.postMessage(jsonStr)
            } else if (this.os === 'android') {
                return window.android.js2native(jsonStr)
            } else {
                console.error('发送原生消息失败', message)
            }
        } catch (e) {
            console.log('函数内错误', e)
        }
    }

    handleMessage(message) {
        if (!isInApp) return
        try {
            const {
                actionName
            } = message
            if (!this.isSupportAction(actionName)) console.error('不支持的action')
            else {
                const {
                    type,
                    params
                } = message.params
                if (actionName === 'pushWeb') {





                } else if (actionName === 'notice') {
                    if (type === 'appState') {
                        if (params.state === 'becomeActive') {

                        }
                    }
                    else if (type === 'payCallback') {
                        this.callbackCache && this.callbackCache()
                    } else if (type === 'getStorage') {
                        return localStorage.getItem(params.key)
                    } else if (type == 'parseUniversalLinks') {
                        console.log(params, 'parseUniversalLinks 获取的链接')
                        let param = {}


                    } else if (type === 'notification') {


                    } else if (type === 'getWechatCode') {

                    }
                }

                return ''
            }
        } catch (e) {
            console.log('函数内错误', e)
        }
    }
}